import { request } from '@/helpers/apiClient'
import { INVENTORY_CONFIG } from '@/utils/constants/apiConfig/inventoryConfig'

export const getInventory = (body, queryParams) => request(INVENTORY_CONFIG.INVENTORY(queryParams), { data: body })

export const getInventoryUploadHistory = () => request(INVENTORY_CONFIG.INVENTORY_UPLOAD_HISTORY)
export const getInventoryCsvFile = (body, queryParams) => request(INVENTORY_CONFIG.INVENTORY_CSV_DOWNLOAD(queryParams), { data: body })
